import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { SuccessDialogComponent } from '../../success-dialog/success-dialog.component';
import * as alertify from "alertifyjs";
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiServiceService } from 'src/app/Services/api-service.service';
import { DownloadService } from 'src/app/Services/app-service/download.service';
import { CardType, PrintDto } from 'src/app/models/printDto';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { QueryModalComponent } from '../../query-modal/query-modal.component';
import { Location } from '@angular/common';
import { PublicPaymentModalComponent } from 'src/app/Module/Main/public-payment-modal/public-payment-modal.component';
import { AuthService } from 'src/app/Services/auth.service';
import { RemitaPaymentDto } from 'src/app/models/remiteResponse.model';
import {NonTaxEdditComponent} from "../../../../Module/Admin/non-tax-assessments/non-tax-eddit/non-tax-eddit.component";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-non-tax-demand-notice',
  templateUrl: './non-tax-demand-notice.component.html',
  styleUrls: ['./non-tax-demand-notice.component.css']
})
export class NonTaxDemandNoticeComponent implements OnInit {


  @Output() onConfirmClicked = new EventEmitter();
  @Input() assessmentId: any;

  // assessmentId: any;
  details: any;
  expiryYear: any
  form: FormGroup;
  isLoading: boolean | undefined;
  isEmpty: boolean | undefined;
  isDownloading: boolean;
  
  
    constructor(
    private route: ActivatedRoute,
    private apiService: ApiServiceService,
    private bsModalService: BsModalService,
    private bsModalRef: BsModalRef,
    private location: Location,
    private router: Router,
    private fb: FormBuilder,
    private downloadService: DownloadService,
    private authenticationService: AuthService,
    ) {
      this.form = this.fb.group({
        assessmentId: [''],
        type: ['APPROVED'],
        assessmentClass: [''],
      });
     }
  
    ngOnInit(): void {
      
      // this.route.params.subscribe(params => {
      //   this.assessmentId = params['assessmentId'];
      // });
      this.getNonTaxAssessment();
    }

    

    testReport() {
      const url = "/assessments/get/report";
      this.apiService.get(url).subscribe(
        (response) => {
        
        },
        (error) => {
          console.log(error);
        }
      );
      
      }

      goToChart(){
        
      }

     


    download(id:any){
      
      const dto:PrintDto = {
        id: id,
        type: CardType.DIRECT_ASSESSMENT
      }

      const dtos:PrintDto[] = new Array<PrintDto>();
      dtos.push(dto)

      const url = "/assessments/downloads/assessments";
      this.apiService.post(url, dtos).subscribe(
        (response) => {
          this.downloadService.download(response)
        },
        (error) => {
          console.log(error);
        }
      );
      
    }

    getNonTaxAssessment(){
      this.isLoading = true;
      this.isEmpty = false;
      const url = `/assessments/view/non-tax-assessment/${this.assessmentId}`;
      this.apiService.get(url).subscribe(
        (response) => {
          
          this.details = response.data;
          var filingDate = new Date(this.details.filingDate);
          this.expiryYear = filingDate.getFullYear();
          this.isLoading = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isEmpty = true;
        }
      );
    }

    confirmApprove() {
      let dfModalRef = this.bsModalService.show(ConfirmDialogComponent, {
        initialState: {
          body: "Are you sure you want to approve this assessment?"
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        this.approve();
  
        dfModalRef.hide();
      });
    }

    query(){

      let dfModalRef = this.bsModalService.show(QueryModalComponent, {
        initialState: {
          body: "Are you sure you want to approve this assessment?",
          assessmentId: this.assessmentId,
          assessmentClass: "non-tax"
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        this.approve();
  
        dfModalRef.hide();
      });

    }

    close() {
      this.onConfirmClicked.emit();
      this.bsModalRef.hide();
    }
  
  
    approve(){
  
      let url = "/assessments/query"

      this.form.patchValue({'assessmentId': this.assessmentId})
      this.form.patchValue({'assessmentClass': "non-tax"})
  
      this.apiService.post(url, this.form.value).subscribe(
        (response) => {
          
          alertify.set("notifier", "position", "top-center");
          alertify.success("Assessment approved successfully");

          this.goBack()
          
        },
        (error) => {
         
          this.confirmAfterError("Action was not successful");
          alertify.set("notifier", "position", "top-center");
          alertify.error("Error performing this operation");
          
        }
      );
    }

    goBack() {
      this.location.back();
    }


    downloadNotice(){

      this.isDownloading = true;

      let url = "/assessments/get/non-tax-demand-notice-assessment";

      let dto = this.details;

      dto.expiryYear = this.expiryYear;
      dto.assessmentId = this.details?.assessmentId;
      let filingDate = new Date(dto.filingDate);
      let filingDateStr = `${filingDate.getDate()}/${filingDate.getMonth() + 1}/${filingDate.getFullYear()}`;
      dto.filingDate = filingDate; 
      dto.assessmentTitle = dto.assessmentType;
      dto.taxDue = dto.amount - 550;
      dto.displayName = dto.assessed;
      dto.createdBy = dto.assessedBy;
      dto.dateCreated = filingDateStr;
      dto.totalTaxDue = dto.amount;
      dto.developmentLevy = 500;
      dto.stampDuty = 50;
      dto.paymentStatus = dto.paymentStatus == 'NOT_PAID' ? 'Not Paid' : 'Paid';



     

      if(this.details?.assessmentType == 'BUSINESS_PREMISES'){
        url = "/assessments/get/business-premises-demand-notice-assessment";
        dto.taxDue = dto.amount ;
        

      }else if(this.details?.assessmentType == 'ASWAMA'){

        url = "/assessments/get/aswama-demand-notice-assessment";
        dto.taxDue = dto.amount;
       
      }

      else if(this.details?.assessmentType == 'FIRE_SERVICE'){

        url = "/assessments/get/fire-service-demand-notice-assessment";
        dto.taxDue = dto.amount;
       
      }

  
  
    this.apiService.post(url, dto, { responseType: 'blob' }).subscribe(
      (response: Blob) => {
  
        const blob = new Blob([response], { type: 'application/pdf' });
  
        // Create a Blob URL for the PDF content
        const blobUrl = window.URL.createObjectURL(blob);
  
        // Open PDF in a new tab
        // window.open(blobUrl, '_blank');
  
        const file = new Blob([response], { type: 'application/pdf' });
  
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
  
        // Optionally, trigger a download by creating an anchor element
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.target = '_blank';
        downloadLink.download = this.details.asin+'_demand_notice.pdf'; // File name for download
  
        // Uncomment this line to trigger the download automatically
        downloadLink.click();
  
        alertify.set("notifier", "position", "top-center");
        alertify.success("Download successful");
        this.isDownloading = false
      },
      (error) => {
        this.isLoading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
        this.isEmpty = true;
        this.isDownloading = false
      }
    );
    }
  
    confirmAfterSuccess(message: any) {
      let dfModalRef = this.bsModalService.show(SuccessDialogComponent, {
        initialState: {
          body: message,
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {

        dfModalRef.hide();
        
      });

      this.goBack()
    }
  
    
  
    confirmAfterError(message: any) {
      let dfModalRef = this.bsModalService.show(ErrorDialogComponent, {
        initialState: {
          body: message,
        },
        class: "modal-sm modal-dialog-centered",
      });
      dfModalRef?.content?.onConfirmClicked.subscribe((v) => {
        dfModalRef.hide();
      });
    }

    payOnline() {
      const returnBackUrl = environment.url + "payment/successful-payment";
      this.isLoading = false;
      let requestRemitaRRR:RemitaPaymentDto = {
          returnBackUrl : returnBackUrl,
          totalAmount : this.details.amount,
          fullName : this.details.assessed,
          customerId : this.details.asin,
          email:this.details.email,
          taxGroup:"INDIVIDUAL",
          phoneNumber:this.details.phoneNumber,
          entityType: "NON MDA",
          entityGroup: "FLAT",
          accessedBy:this.authenticationService.getDisplayName(),
      }

      switch (this.details?.assessmentType) {
        case 'PRESUMPTIVE_TAX':
          requestRemitaRRR.mdaRecordId = 159;
          requestRemitaRRR.revenueName = "Presumptive Tax (PT)";
          requestRemitaRRR.revenueId = "20008001-12010045";
          requestRemitaRRR.feeDescription = "Presumptive Tax (PT)";
          requestRemitaRRR.entityName = "Presumptive Tax (PT)";
          break;
      
        case 'ASWAMA':
          requestRemitaRRR.mdaRecordId = 261;
          requestRemitaRRR.revenueName = "Waste Collection Fees";
          requestRemitaRRR.revenueId = "35016001-12040319";
          requestRemitaRRR.feeDescription = "Waste Collection Fees";
          requestRemitaRRR.entityName = "Waste Collection Fees";
          break;
      
        case 'BUSINESS_PREMISES':
          requestRemitaRRR.mdaRecordId = 1266;
          requestRemitaRRR.revenueName = "Registration of Business Premises (Current)";
          requestRemitaRRR.revenueId = "22001001-12040125";
          requestRemitaRRR.feeDescription = "Registration of Business Premises (Current)";
          requestRemitaRRR.entityName = "Registration of Business Premises (Current)";
          break;
      
        case 'FIRE_SERVICE':
          requestRemitaRRR.mdaRecordId = 1090;
          requestRemitaRRR.revenueName = "Fire Service Fees";
          requestRemitaRRR.revenueId = "61001001-12040465";
          requestRemitaRRR.feeDescription = "Fire Service Fees";
          requestRemitaRRR.entityName = "Fire Service Fees";
          break;
      
        default:
          
          break;
      }
      

      this.close();
      let bsModalRef = this.bsModalService.show(PublicPaymentModalComponent, {
          initialState: {
              details: requestRemitaRRR
          },
          backdrop: true,
          class: 'modal-md modal-dialog-centered',
          ignoreBackdropClick: true,
      });
      bsModalRef?.content?.onConfirmClicked.subscribe(v => {
          bsModalRef.hide();
      });
      // sessionStorage.setItem('paymentInfo', JSON.stringify(requestRemitaRRR));
      // this.router.navigate(['/payment/online-payment']);
  }


  openEdit() {
      this.close();
    let bsModalRef = this.bsModalService.show(NonTaxEdditComponent, {
      class: 'modal-lg modal-dialog-centered',
      ignoreBackdropClick: true,
      animated: true,
      backdrop: true,
      initialState: {
        details: this.details,
      }
    });
    bsModalRef?.content?.onConfirmClicked.subscribe(v => {
      bsModalRef.hide();
    });
  }
}
